import "bootstrap/dist/css/bootstrap.min.css";
import { Routes, Route } from 'react-router-dom'; 
import Menu from "./components/Menu/Menu";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Home from "./pages/Home/Home";
import Service from "./pages/Services/Service";
import "./App.css";

function App() {
  return (
    <>
      <Menu />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicos" element={<Service/>} />
        </Routes>
    </>
  );
}

export default App;